import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from 'react-router-dom';
import { post } from "../utils/apiManager";
import { toast } from "react-toastify";
import { baseURL } from "../config/config";
import { useState } from "react";

const EyeIcon = ({ show }) => (
  <span style={{ fontSize: 16, lineHeight: 1 }}>
    {show ? "🙈" : "👁️"}
  </span>
);

const ChangePassword = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const Navigate = useNavigate();
  const location = useLocation();
  const id = location?.search?.split("?")[1];
  const [loading, setLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validatePassword = (value) => (
    /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}$/.test(value) ||
    "Must contain a number, uppercase letter, special character, and be 8+ characters"
  );

  const onSubmit = (data) => {
    if (data.newPassword !== data.confirmPassword) return toast.error("Passwords do not match");
    setLoading(true);
    post(`${baseURL}/company/change-password`, { ...data, id })
      .then((res) => { setLoading(false); if (res?.status) { toast.success(res?.message || 'Password updated'); Navigate("/admin/user"); } else toast.error(res?.message || 'Could not update password'); })
      .catch((err) => { setLoading(false); toast.error(err?.response?.data?.message || err?.response?.data?.error || 'Could not update password'); });
  };

  const inputS = (err) => ({ width: '100%', padding: '10px 40px 10px 14px', borderRadius: 8, border: `1.5px solid ${err ? '#AD2429' : '#e2e8f0'}`, fontSize: 14, color: '#0a1628', background: '#fff', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' });

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden', maxWidth: 600 }}>
        <div style={{ padding: '18px 28px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Change Company Password</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Set a new password for this company account</p>
          </div>
          <button onClick={() => Navigate('/admin/user')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} style={{ padding: '28px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 24 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'flex', gap: 4 }}>New Password <span style={{ color: '#AD2429' }}>*</span></label>
              <div style={{ position: 'relative' }}>
                <input placeholder="New Password" type={showNewPassword ? "text" : "password"} style={inputS(errors.newPassword)}
                  {...register("newPassword", { required: "Required", validate: validatePassword })} />
                <button
                  type="button"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  style={{
                    position: 'absolute',
                    right: 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <EyeIcon show={showNewPassword} />
                </button>
              </div>
              {errors.newPassword && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>{errors.newPassword.message}</span>}
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'flex', gap: 4 }}>Confirm Password <span style={{ color: '#AD2429' }}>*</span></label>
              <div style={{ position: 'relative' }}>
                <input placeholder="Confirm Password" type={showConfirmPassword ? "text" : "password"} style={inputS(errors.confirmPassword)}
                  {...register("confirmPassword", { required: "Required" })} />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    position: 'absolute',
                    right: 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <EyeIcon show={showConfirmPassword} />
                </button>
              </div>
              {errors.confirmPassword && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>{errors.confirmPassword.message}</span>}
            </div>
          </div>
          <div style={{ padding: '12px 16px', background: '#fffbeb', borderRadius: 8, border: '1px solid #fef3c7', fontSize: 12, color: '#92400e', marginBottom: 20 }}>
            Password must be 8+ characters with at least one number, uppercase letter, and special character.
          </div>
          <div style={{ paddingTop: 16, borderTop: '1px solid #edf0f7', display: 'flex', gap: 12 }}>
            <button type="submit" disabled={loading} style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '11px 28px', fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Saving...' : 'Update Password'}
            </button>
            <button type="button" onClick={() => Navigate('/admin/user')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '11px 22px', fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
